import {ModalForm, ProFormDependency, ProFormText} from '@ant-design/pro-form';
import React, {useEffect, useState} from 'react';
import {useIntl} from "umi";
import type {ResetPwdParams} from "@/components/RightContent/data";
import md5 from 'md5';
import { Alert } from 'antd';
import { getSetting } from '@/services/basic';

const defaultPwdPattern = /^(?=.*\d)(?=.*[a-zA-Z])(?!.*[\u4e00-\u9fa5]).{6,}$|^(?=.*\d)(?=.*[^\s\da-zA-Z])(?!.*[\u4e00-\u9fa5]).{6,}$|^(?=.*[^\s\da-zA-Z])(?=.*[a-zA-Z])(?!.*[\u4e00-\u9fa5]).{6,}$/;

interface ModalProps {
  children?: React.ReactElement;
  onSubmit: (params: ResetPwdParams  ) => void
}

const UpdateUserInfoModal: React.FC<ModalProps> = (props) => {
  const intl = useIntl();
  const c = window.$tc('', intl.formatMessage);
  const [showError,setError]=useState<Boolean>(false)
  const [pwdPattern,setPwdPattern]=useState(defaultPwdPattern)
  const [ruleMsg,setRulemsg]=useState(c('component.GlobalHeaderRight.index.t43', "注：密码长度需大于6位（含），支持输入字母、数字和字符，且必须包含2项以上。设置成功后需重新登录。"))
  const getPwdPattern= async ()=>{
    const res =await getSetting({confKey:'tenant:user-password-settings'})

    if(res.code===200){

      setPwdPattern(new RegExp(res.data.confValue))
    }
  }
  useEffect(()=>{
    getPwdPattern()
  },[])
  const validatorPwd = (_, value: string) => {
    if (pwdPattern?.test(value)) {
      return Promise.resolve()
    }
    return Promise.reject()
  }
  const validatorAgainPwd = (pwd1: string, pwd2: string) => {
    if (!pwd1 || !pwd2 || pwd1 === pwd2) {
      return Promise.resolve()
    }
    return Promise.reject()
  }
  return (
    <div>
      <ModalForm
        scrollToFirstError
        layout="horizontal"
        title={c('component.GlobalHeaderRight.index.t19', "修改密码")}
        trigger={props.children}
        name={'UpdatePwd'}
        modalProps={{
          destroyOnClose:true
        }}
        labelCol={{ span: 5 }}
        wrapperCol={{ span: 16 }}
        onFinish={async ({newPassword,oldPassword})=>{
          if(props.onSubmit){
            return props.onSubmit({newPassword,oldPassword:md5(oldPassword),})
          }
        }}
      >
        {showError && <Alert
          message={c('component.GlobalHeaderRight.index.t48', '两次密码不一致！')}
          type="error" showIcon />}
        <ProFormText.Password
          label={c('component.GlobalHeaderRight.index.t49', '旧密码')}
          name="oldPassword"
          validateFirst
          fieldProps={{
            autoComplete:"new-password"
          }}
          rules={[
            {required: true},

          ]}
        />
        <ProFormText.Password
          validateFirst
          label={c('component.GlobalHeaderRight.index.t50', '新密码')}
          name="newPassword"
          rules={[
            {required: true},
            {validator: validatorPwd, message: c('component.GlobalHeaderRight.index.t20', '请设置正确的密码格式！')},
          ]}
          extra={ruleMsg}
        />
        <ProFormDependency name={['newPassword','againPassWord']}>
          {({newPassword}) => {
            return (<ProFormText.Password
              validateFirst
              label={c('component.GlobalHeaderRight.index.t51', '再次输入')}
              name="againPassWord"
              rules={[
                {required: true},
                {validator: validatorPwd, message: c('component.GlobalHeaderRight.index.t20', '请设置正确的密码格式！')},
                {
                  validator: (_, value) => {
                    return validatorAgainPwd(value, newPassword)
                  }, message: c('component.GlobalHeaderRight.index.t48', '两次密码不一致！')
                }
              ]}
            />)
          }}
        </ProFormDependency>

      </ModalForm>

    </div>
  );
};

export default UpdateUserInfoModal;
